module.exports = __webpack_public_path__ + "static/media/ticket_campaign_preview_instruction_content_pic.e22854f4.svg";